export abstract class NewHttpDao {
  abstract getData(search: any, sort: string, order: string, limit: number, page: number);
}



// WEBPACK FOOTER //
// /home/web_clients/qualicheck.fr/preprod/erp/src/app/core/utils/new-http-dao.ts